
export const OPEN_AREA_MODAL = "open_area_modal";
export const CLOSE_AREA_MODAL = "close_area_modal";
export const AREA_CREATED = "area_created"
export const AREA_UPDATED = "area_updated";
export const GET_AREA_LIST = "get_area_list";